import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=4679dc60&scoped=true&"
import script from "./LoadingView.vue?vue&type=script&lang=js&"
export * from "./LoadingView.vue?vue&type=script&lang=js&"
import style0 from "./LoadingView.vue?vue&type=style&index=0&id=4679dc60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679dc60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
